import { tracker } from '.';
import { TreeSelectOnChangeEventProps } from './tree-select-onchange';

let eventSent = false;

export const subjectOnChangeEventHandler = (props: TreeSelectOnChangeEventProps) => {
  if (eventSent) return;

  const { originalValue, value } = getValues(props);

  if (!originalValue || originalValue.length !== 1) return;

  const originalValueIsPresent = value.find(({ id }) => originalValue[0].id === id);
  if (originalValueIsPresent) return;

  tracker
    .track({
      eventName: 'removePreselectedSubject',
      properties: {
        subject: originalValue[0].id,
      },
    })
    .then(() => {
      eventSent = true;
    });
};

let firstOriginalValue;

const getValues = (props: TreeSelectOnChangeEventProps): TreeSelectOnChangeEventProps => {
  let { originalValue } = props;

  if (!firstOriginalValue && originalValue && originalValue.length === 1) {
    firstOriginalValue = originalValue;
  }

  if (firstOriginalValue) {
    originalValue = firstOriginalValue;
  }

  return {
    ...props,
    originalValue,
  };
};
